<template>
  <div class="chart-container">
    <table
      id="bar-chart"
      class="
        customchart
        charts-css
        column
        show-labels show-primary-axis show-3-secondary-axes
        data-spacing-6
      "
    >
      <caption>
        {{
          title
        }}
      </caption>
      <thead>
        <tr>
          <th scope="col">Date</th>
          <th scope="col">Score</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in chartData" v-bind:key="index">
          <th class="axis-th" scope="row">
            <span class="screen-reader-text">table column</span>
            <div class="axis-label">
              <span
                >{{ item.day }}<br />
                {{ item.month }}<br /></span
              ><span
                ><strong>{{ item.time }}</strong></span
              >
            </div>
          </th>
          <td v-bind:style="item.style">
            <span
              v-popover="{
                name: 'answer' + item.answer,
                position: gettooltipposition(index),
                width: 100,
              }"
              v-bind:title="item.tooltip"
              v-if="item.time.length > 0"
              class="bar-label"
              > 
              <span class="bar-label--agree" v-if="item.answer == 2"><i class="fa fa-smile fa-smile--active"></i></span>
              <span class="bar-label--neutral" v-if="item.answer == 1"><i class="fa fa-meh fa-meh--active"></i></span>
              <span class="bar-label--disagree" v-if="item.answer == 0"><i class="fa fa-frown fa-frown--active"></i></span>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
    <div id="popups">
      <div v-for="(item, index) in $answerNames" v-bind:key="index">
        <popover v-bind:name="'answer' + index">
          {{ item }}
        </popover>
      </div>
    </div>
  </div>
</template>

<script>
import helper from "../../helpers/helper.js";

export default {
  name: "barChart",
  props: {
    data: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      chartData: [],
      answer_: null,
      barColour: "",
    };
  },
  mounted() {
    this.data.forEach((e) => {
      if (e.date.length > 0 && e.answer) {
        // let date = helper.getDateAsNumber(e.date);
        if (e.answer === "Agree") {
          this.answer_ = 2;
          this.barColour = "#D6EEE5";
        } else if (e.answer === "Neutral") {
          this.answer_ = 1;
          this.barColour = "#FBF0E2";
        } else if (e.answer === "Disagree") {
          this.answer_ = 0;
          this.barColour = "#F9DFDF";
        } else if (e.answer === "Not answered") {
          this.answer_ = -1;
          this.barColour = "#eeeeee";
        }
        let step = this.answer_ * 0.333 + 0.333;
        let s = "--border:1px solid; --border-bottom:none; --size: " + step + "; --color: " + this.barColour;
        this.chartData.push({
          style: s,
          day: helper.getDay(e.date),
          month: helper.getMonth(e.date),
          time: helper.getTime(e.date),
          year: helper.getYear(e.date),
          answer: this.answer_,
          tooltip: e.tooltip,
        });
      } else {
        this.chartData.push({
          style: "--border:1px solid; --border-bottom:none; --size: 0;",
          day: "",
          month: "",
          time: "",
          year: "",
          answer: "",
          tooltip: "",
        });
      }
    });
  },
  methods: {
    gettooltipposition: function (idx) {
      let pos = "left";
      if (idx < 3) {
        pos = "right";
      }
      return pos;
    },
  },
};
</script>
